import _ from "lodash";

function clone(x) {
  var prefixPattern, exactPattern, dupe;

  if (!x) {
    return null;
  }

  // TODO: in the next major version, we should
  // consider removing these pattern properties.
  // They are not useful extnerally and can be
  // confusing because the exactPattern does not
  // always match (for instance, Maestro cards
  // can start with 62, but the exact pattern
  // does not include that since it would
  // exclude UnionPay and Discover cards
  // when it is not sure whether or not
  // the card is a UnionPay, Discover or
  // Maestro card).
  prefixPattern = x.prefixPattern.source;
  exactPattern = x.exactPattern.source;
  dupe = JSON.parse(JSON.stringify(x));
  dupe.prefixPattern = prefixPattern;
  dupe.exactPattern = exactPattern;

  return dupe;
}

var types = {};
var VISA = "visa";
var MASTERCARD = "master-card";
var AMERICAN_EXPRESS = "american-express";
var DINERS_CLUB = "diners-club";
var DISCOVER = "discover";
var JCB = "jcb";
var UNIONPAY = "unionpay";
var MAESTRO = "maestro";
var CVV = "CVV";
var CID = "CID";
var CVC = "CVC";
var CVN = "CVN";
var testOrder = [
  VISA,
  MASTERCARD,
  AMERICAN_EXPRESS,
  DINERS_CLUB,
  DISCOVER,
  JCB,
  UNIONPAY,
  MAESTRO,
];

types[VISA] = {
  niceType: "Visa",
  type: VISA,
  typeCode: "VI",
  prefixPattern: /^4$/,
  exactPattern: /^4\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: CVV,
    size: 3,
  },
  image:
    "data:image/svg+xml;utf8;base64,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",
};

types[MASTERCARD] = {
  niceType: "MasterCard",
  type: MASTERCARD,
  typeCode: "CA",
  prefixPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27|27[0-2]|2720)$/,
  exactPattern: /^(5[1-5]|222[1-9]|2[3-6]|27[0-1]|2720)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVC,
    size: 3,
  },
  image:
    "data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjQgNDhDMzcuMjU0OCA0OCA0OCAzNy4yNTQ4IDQ4IDI0QzQ4IDEwLjc0NTIgMzcuMjU0OCAwIDI0IDBDMTAuNzQ1MiAwIDAgMTAuNzQ1MiAwIDI0QzAgMzcuMjU0OCAxMC43NDUyIDQ4IDI0IDQ4WiIvPjxwYXRoIGZpbGw9IiNGNzlGMUEiIGQ9Ik0zOC4zNzg5IDI0LjExNTZDMzguMzc4OSAyOS4wMzg2IDM0LjM5NTYgMzMuMDI5NCAyOS40ODIgMzMuMDI5NEMyNC41Njg0IDMzLjAyOTQgMjAuNTg1MSAyOS4wMzg2IDIwLjU4NTEgMjQuMTE1NkMyMC41ODUxIDE5LjE5MjcgMjQuNTY4NCAxNS4yMDE5IDI5LjQ4MiAxNS4yMDE5QzM0LjM5NTYgMTUuMjAxOSAzOC4zNzg5IDE5LjE5MjcgMzguMzc4OSAyNC4xMTU2WiIvPjxwYXRoIGZpbGw9IiNFQTAwMUIiIGQ9Ik0yNy40MDMyIDI0LjExNTZDMjcuNDAzMiAyOS4wMzg2IDIzLjQyIDMzLjAyOTQgMTguNTA2MyAzMy4wMjk0QzEzLjU5MjcgMzMuMDI5NCA5LjYwOTQ0IDI5LjAzODYgOS42MDk0NCAyNC4xMTU2QzkuNjA5NDQgMTkuMTkyNyAxMy41OTI3IDE1LjIwMTkgMTguNTA2MyAxNS4yMDE5QzIzLjQyIDE1LjIwMTkgMjcuNDAzMiAxOS4xOTI3IDI3LjQwMzIgMjQuMTE1NloiLz48cGF0aCBmaWxsPSIjRkY1RjAxIiBkPSJNMjMuOTk0MiAxNy4wOTg2QzIxLjkxODMgMTguNzMwNCAyMC41ODU4IDIxLjI2NjIgMjAuNTg1OCAyNC4xMTQ4QzIwLjU4NTggMjYuOTYzMyAyMS45MTgzIDI5LjUwMSAyMy45OTQyIDMxLjEzMjhDMjYuMDcgMjkuNTAxIDI3LjQwMjYgMjYuOTYzMyAyNy40MDI2IDI0LjExNDhDMjcuNDAyNiAyMS4yNjYyIDI2LjA3IDE4LjczMDQgMjMuOTk0MiAxNy4wOTg2WiIvPjwvc3ZnPg==",
};

types[AMERICAN_EXPRESS] = {
  niceType: "American Express",
  type: AMERICAN_EXPRESS,
  typeCode: "AX",
  prefixPattern: /^(3|34|37)$/,
  exactPattern: /^3[47]\d*$/,
  isAmex: true,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: CID,
    size: 4,
  },
  image:
    "data:image/svg+xml;utf8;base64,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",
};

types[DINERS_CLUB] = {
  niceType: "Diners Club",
  type: DINERS_CLUB,
  typeCode: "XX",
  prefixPattern: /^(3|3[0689]|30[0-5])$/,
  exactPattern: /^3(0[0-5]|[689])\d*$/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: CVV,
    size: 3,
  },
};

types[DISCOVER] = {
  niceType: "Discover",
  type: DISCOVER,
  typeCode: "XX",
  prefixPattern: /^(6|60|601|6011|65|64|64[4-9])$/,
  exactPattern: /^(6011|65|64[4-9])\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: CID,
    size: 3,
  },
};

types[JCB] = {
  niceType: "JCB",
  type: JCB,
  typeCode: "XX",
  prefixPattern: /^(2|21|213|2131|1|18|180|1800|3|35)$/,
  exactPattern: /^(2131|1800|35)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVV,
    size: 3,
  },
};

types[UNIONPAY] = {
  niceType: "UnionPay",
  type: UNIONPAY,
  typeCode: "XX",
  prefixPattern: /^((6|62|62\d|(621(?!83|88|98|99))|622(?!06)|627[02,06,07]|628(?!0|1)|629[1,2])|622018)$/,
  exactPattern: /^(((620|(621(?!83|88|98|99))|622(?!06|018)|62[3-6]|627[02,06,07]|628(?!0|1)|629[1,2]))\d*|622018\d{12})$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVN,
    size: 3,
  },
};

types[MAESTRO] = {
  niceType: "Maestro",
  type: MAESTRO,
  typeCode: "XX",
  prefixPattern: /^(5|5[06-9]|6\d*)$/,
  exactPattern: /^(5[06-9]|6[37])\d*$/,
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: CVC,
    size: 3,
  },
};

export function creditCardType(cardNumber) {
  var type, value, i;
  var prefixResults = [];
  var exactResults = [];

  for (i = 0; i < testOrder.length; i++) {
    type = testOrder[i];
    value = types[type];

    if (cardNumber.length === 0) {
      prefixResults.push(clone(value));
      continue;
    }

    if (value.exactPattern.test(cardNumber)) {
      exactResults.push(clone(value));
      //return exactResults;
    } else if (value.prefixPattern.test(cardNumber)) {
      prefixResults.push(clone(value));
      //return prefixResults;
    }
  }

  if (_.isEmpty(exactResults) && _.isEmpty(prefixResults)) {
    return null;
  } else {
    return exactResults.length ? exactResults : prefixResults;
  }
}

export function validateCreditCard(value, detectedCreditCard) {
  if (
    detectedCreditCard &&
    detectedCreditCard.lengths.indexOf(value.length) === -1
  ) {
    return "Credit card number contains invalid number of characters.";
  }
}
